// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sl-0";